"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _textInputData = require("../constants/textInputData");
const styleOverrides = {
  root: ({
    theme
  }) => ({
    [`&.OriSelectList .${_material.menuItemClasses.root}`]: {
      fontSize: theme.typography.body2.fontSize,
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: 10,
      paddingRight: 12,
      whiteSpace: 'initial'
    },
    [`&.OriSelectList .${_material.menuItemClasses.root}::after`]: {
      content: '""',
      flexShrink: 0,
      display: 'block',
      overflow: 'hidden',
      width: '24px',
      height: '24px',
      background: 'transparent'
    },
    [`&.OriSelectList .${_material.menuItemClasses.root}:focus`]: {
      backgroundColor: theme.palette.primary.light
    },
    [`&.OriSelectList .${_material.menuItemClasses.root}:hover`]: {
      backgroundColor: theme.palette.primary.light
    },
    [`&.OriSelectList .${_material.menuItemClasses.selected}:focus`]: {
      backgroundColor: 'transparent'
    },
    [`&.OriSelectList .${_material.menuItemClasses.selected}:hover`]: {
      backgroundColor: theme.palette.primary.light
    },
    [`&.OriSelectList .${_material.menuItemClasses.selected}::after`]: {
      fill: theme.palette.success.main,
      content: _textInputData.selectedMark
    }
  })
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiList.js.map